import { render } from "./user-quotes.vue?vue&type=template&id=44b5a932&scoped=true"
import script from "./user-quotes.vue?vue&type=script&lang=js"
export * from "./user-quotes.vue?vue&type=script&lang=js"

import "./user-quotes.vue?vue&type=style&index=0&id=44b5a932&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44b5a932"]])

export default __exports__